import 'isomorphic-fetch';
import baseFetch, { createParamString } from '../baseFetch';
import { getMeterParamsForRequest } from '../../utils/meteringHelper';

export const fetchLegacyChartImages = (legacyId, type, nearshoreModelName, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/charts/legacy/images?${createParamString({
      legacyId,
      type,
      nearshoreModelName,
      meterRemaining,
    })}`,
    {
      ...meterHeaders,
    },
  );
};

export const fetchLegacyChartTypes = (subregionId, cookies, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(`/charts/legacy/types?${createParamString({ subregionId, meterRemaining })}`, {
    cookies,
    ...meterHeaders,
  });
};
